/* eslint-disable */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout/Layout';
import About from './components/Sections/About';
import Services from './components/Sections/Services';
import Features from './components/Sections/Features';
import Products from './components/Sections/Products';
import Contact from './components/Sections/Contact';
import Login from './admin/Login';
import Register from './admin/Register';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import ManageProducts from './admin/ManageProducts';
import ManageContent from './admin/ManageContent';
import ManageSponsors from './admin/ManageSponsors';
import EditSponsor from './admin/EditSponsor';
import Settings from './admin/Settings';
import PrivateRoute from './components/Auth/PrivateRoute';
import Home from './components/Sections/Home';
import News from './components/Sections/News';
import NewsDetail from './components/Sections/NewsDetail';
import ManageNews from './admin/ManageNews';
import ManageQuote from './admin/ManageQuote';
import './components/Sections/styles.css'

function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="programs" element={<Services />} />
          <Route path="features" element={<Features />} />
          <Route path="products" element={<Products />} />
          <Route path="contact" element={<Contact />} />
          <Route path="news" element={<News />} />
          <Route path="news/:name" element={<NewsDetail />} />  
        </Route>

        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/register" element={<Register />} /> 
        
  
        <Route path="/admin" element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
           }>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="/admin/products" element={<ManageProducts />} />
          <Route path="/admin/sponsors" element={<ManageSponsors />} />
          <Route path="/admin/sponsors/:id" element={<EditSponsor />} />
          <Route path="/admin/content" element={<ManageContent />} />
          <Route path="/admin/messages" element={<ManageQuote />} />
          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin/news" element={<ManageNews />} />
        </Route>

        <Route path="*" element={
          <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>404 - Page Not Found</h1>
            <p>The page you are looking for doesn't exist.</p>
          </div>
        } />
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;